import { render, staticRenderFns } from "./transact.vue?vue&type=template&id=22ee974d&scoped=true&"
import script from "./transact.vue?vue&type=script&lang=js&"
export * from "./transact.vue?vue&type=script&lang=js&"
import style0 from "./transact.vue?vue&type=style&index=0&id=22ee974d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee974d",
  null
  
)

export default component.exports